/**
 * "Top of mind" home-page section.
 * Auto-playing muted looping video on the left, brand copy on the right.
 */
export default function TopOfMind() {
  return (
    <section
      data-testid="top-of-mind-section"
      className="relative py-24 md:py-32 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-12">
          <span className="text-xs uppercase tracking-[0.22em] text-zinc-500 font-mono">
            §07 · Top of mind
          </span>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* LEFT — video */}
          <div className="lg:col-span-6 flex justify-center lg:justify-start">
            <video
              data-testid="top-of-mind-video"
              src="/video/iphone-animation.mp4"
              autoPlay
              loop
              muted
              playsInline
              preload="metadata"
              className="w-full max-w-md h-auto block"
            />
          </div>

          {/* RIGHT — copy */}
          <div className="lg:col-span-6">
            <p className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-light leading-snug text-zinc-300">
              No one wants to update your
              {" "}<span className="italic text-zinc-500">iOS app</span>{" "}
              again. And your emails go to{" "}
              <span className="italic text-zinc-500">&quot;Promotions.&quot;</span>
            </p>

            <p className="mt-8 font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-light leading-snug text-white">
              <span className="text-yellow-400">iMessage / SMS</span> goes
              straight to the top of their inbox.{" "}
              <span className="block mt-3 italic font-extralight text-zinc-400">
                You are always top of mind.
              </span>
            </p>

            <div className="mt-10 flex items-center gap-3">
              <span className="w-2 h-2 bg-green-400 animate-pulse" />
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-zinc-400">
                Already where attention lives
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
